/**
 * Storage key enum
 */
export enum StorageKeyEnum {
  /**
   * UI Language
   */
  UILang = 'uiLang',
  /**
   * Viewer ID；sessionStorage，分頁存活期間穩定；多分頁各自一個 UUID
   */
  ViewerId = 'viewerId',
}
